var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeauty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9.99999H23.8334M15.5 9.99999V14.1667H23.8334V9.99999M15.5 9.99999V7.49999C15.5 4.99999 18 3.33333 20.5 3.33333H29.6667C29.6667 3.33333 23.8334 4.99999 23.8334 8.33333V9.99999M11.3334 15.8333C11.3334 15.3913 11.509 14.9674 11.8215 14.6548C12.1341 14.3423 12.558 14.1667 13 14.1667H26.3334C26.7754 14.1667 27.1993 14.3423 27.5119 14.6548C27.8244 14.9674 28 15.3913 28 15.8333V31.6667C28 31.6667 28 36.6667 23 36.6667H16.3334C11.3334 36.6667 11.3334 31.6667 11.3334 31.6667V15.8333Z",
    stroke: "current",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeauty);
export default __webpack_public_path__ + "static/media/beauty.b1bd54a0.svg";
export { ForwardRef as ReactComponent };